import { Injectable } from '@angular/core';
import { MailjetStatusType } from '@shared/enums/MailjetStatusType';
import { CampaignMailStatistics, ICampaignMailStatistics } from '../api/dashboard/campaigns-service/campaigns.model';
import { IMailStatus } from '../api/legacy/mailstatuses-service/mailstatuses-model';

@Injectable()
export class MailjetStatusesService {
  public CalculateStatuses(mailStatuses: IMailStatus[]): ICampaignMailStatistics {
    const mailStatistics: ICampaignMailStatistics = new CampaignMailStatistics(
      // Total amount of mails without queued and not processed
      mailStatuses?.length,
      // Mails that have been delivered
      mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.Sent)?.length ?? 0,
      mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.Opened)?.length ?? 0,
      mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.Clicked)?.length ?? 0,
      mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.Unsub)?.length ?? 0,
      mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.Spam)?.length ?? 0,
      // Mails that have not been delivered
      mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.Blocked)?.length ?? 0,
      (mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.Softbounced)?.length +
          mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.Hardbounced)?.length +
          mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.Bounce)?.length) ?? 0,
      // Mails that have not been processed by Mailjet
      mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.Queued)?.length ?? 0,
      mailStatuses?.filter(x => x.mailjetStatus === MailjetStatusType.NotProcessed)?.length ?? 0,
      // Total amount of mails that have been delivered
      0
    );
    // Calculate and assign the total amount of mails that have been delivered
    mailStatistics.totalDelivered =
        mailStatistics.totalSent + mailStatistics.totalOpened + mailStatistics.totalClicked + mailStatistics.totalUnsub + mailStatistics.totalSpam;

    return mailStatistics;
  }
}
